module.exports = __webpack_public_path__ + "639cddfd20f7d493746fe6872ca0d72e.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/sponsors-heading-grey.png
// module id = 395
// module chunks = 2